module.exports = __webpack_public_path__ + "img/bg.51e552f4.png";